import { Grid, Button } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { usePersonPageParams } from '../../personPageRouteUtil'
import SectionCardSkeleton from '../../components/section-card/SectionCardSkeleton'
import LatestChangesLoading from './LatestChangesLoading'

export default function LatestChangesCardSkeleton(): JSX.Element {
  const [t] = useTranslation()
  const { pid } = usePersonPageParams('partial')

  return (
    <Grid gutters="nano">
      <SectionCardSkeleton heading={t('tree-person.changelog-summary.label')}>
        <LatestChangesLoading />
        {pid && (
          <Button data-testid="changelog-summary-show-all" linkName="Show All Changelog" to={`/changelog/${pid}`}>
            {t('tree-person.show-all.action')}
          </Button>
        )}
      </SectionCardSkeleton>
    </Grid>
  )
}
